export default {
  search_comment_count: 'Comments',
  search_last_updated: 'Latest update:',
  search_all_search: 'Search for all courses',
  search_little_video: 'Clips',
  search_follow_count: 'Follower(s)',
  search_special_subject: 'Topic',
  search_invitation: 'Post',
  search_post: 'Post',
  search_search_word_after: 'Search results for "{searchWordAfter}"',
  search_open_time: 'Class launch period:',
  search_score: "{score, plural, =0 {no point.} =1 {one point.} other {# points.}}",
  search_pic_num: '{smallImgList, plural, =0 {no images} =1 {one image} other {# images}} in total'
}
